export function getFullURL(pathname: string, searchParams: string | undefined) {
  if (!searchParams) return pathname;

  if (pathname === '/') return '?' + searchParams;

  return pathname + '?' + searchParams;
}
